// extracted by mini-css-extract-plugin
export default {"content":"content__dHN2D","titleHead":"titleHead__HBLOf","mainTitle":"mainTitle__xR613","row":"row__b0qGZ","info":"info__EMOgm"};